/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';

import moment from 'moment';

import CopyToClipboard from 'react-copy-to-clipboard';

import { BiCalendarPlus } from 'react-icons/bi';
import { BiPlus } from 'react-icons/bi';

import Button from '../../../../newComponents/Button';
import Input from '../../../../newComponents/Input';
import ModalCoupon from '../ModalCoupon';
import ModalScheduling from '../ModalScheduling';
import ModalChangeMoney from '../ModalChangeMoney';
import Select, { SelectOptionType } from '../../../../newComponents/Select';
import TextArea from '../../../../newComponents/TextArea';

import * as S from './styles';

import DefaultImg from '../../../../assets/no_image.png';

import { useAuth } from '../../../../hooks/auth';
import { useToast } from '../../../../hooks/toast';

import api from '../../../../services/api';
import empresaApi from '../../../../services/empresaApi';

import moneyMask from '../../../../utils/moneyMask';

import { IFormaPagamentoEmpresa } from '../../../../interfaces/IPaymentMethod';
import { ICustomer } from '../../../../interfaces/ICustomer';
import { ICartItem } from '../../../../interfaces/ICartItem';
import { IDiscountCoupon } from '../../../../interfaces/IDiscountCoupon';
import { formateBrPrice } from '../../../../utils/formateBrPrice';
import CompanyTile from '../CompanyTile';
import { lerChave } from '../../../../utils/chaveFormaPagamento';

interface MainFinishProps {
  cart: ICartItem[];
  companies: {
    id: number;
    name: string;
  }[];
  selectedCompanyId: number;
  scheduledDelivery: Date | null;
  setScheduledDelivery: React.Dispatch<React.SetStateAction<Date | null>>;
  selectedCoupon: IDiscountCoupon | null;
  setSelectedCoupon: React.Dispatch<
    React.SetStateAction<IDiscountCoupon | null>
  >;
  selectedPaymentMethod: {
    paymentMethod: IFormaPagamentoEmpresa;
    changeMoney: number | null;
  } | null;
  setSelectedPaymentMethod: React.Dispatch<
    React.SetStateAction<{
      paymentMethod: IFormaPagamentoEmpresa;
      changeMoney: number | null;
    } | null>
  >;
  setSelectedCompanyId: (id: number) => void;
  finalPrice: number;
  distances: { id: number; distance: number }[];
  setDiscountOnTheOutside: React.Dispatch<React.SetStateAction<number | null>>;
  prevStep: () => void;
  selectedClient: ICustomer | null;

  observation: string;
  setObservation: React.Dispatch<React.SetStateAction<string>>;

  discountOnTheOutside: number | null;
  handleFinalizeOrder: () => Promise<void>;

  isEditing: boolean;
  isLoading: boolean;
}

export const MainFinish: React.FC<MainFinishProps> = (props) => {
  const {
    isEditing,
    cart,
    scheduledDelivery,
    setScheduledDelivery,
    selectedCoupon,
    setSelectedCoupon,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    finalPrice,
    distances,
    setDiscountOnTheOutside,
    prevStep,
    selectedClient,
    observation,
    setObservation,
    discountOnTheOutside,
    handleFinalizeOrder,
    selectedCompanyId,
    setSelectedCompanyId,
    isLoading,
    companies,
  } = props;

  const { addToast } = useToast();
  const { user } = useAuth();

  const [modalSchedulingIsOpen, setModalSchedulingIsOpen] = useState(false);
  const [modalCouponIsOpen, setModalCouponIsOpen] = useState(false);
  const [modalChangeMoneyIsOpen, setModalChangeMoneyIsOpen] = useState(false);

  const [paymentsMethod, setPaymentsMethod] = useState<
    IFormaPagamentoEmpresa[] | null
  >(null);

  const [
    selectedPayment,
    setSelectedPayment,
  ] = useState<IFormaPagamentoEmpresa | null>(null);

  const [changeMoney, setChangeMoney] = useState('R$ 0,00');
  const [discount, setDiscount] = useState(
    discountOnTheOutside === null
      ? 'R$ 0,00'
      : discountOnTheOutside.toFixed(2).replace('.', ','),
  );

  const [scheduledIsActive, setScheduledIsActive] = useState(false);

  const [moneyIsError, setMoneyIsError] = useState(false);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        const { data } = await api.get(
          `formas_pagamento_empresa/${selectedCompanyId}`,
        );
        setPaymentsMethod(
          data.filter(
            (item: IFormaPagamentoEmpresa) =>
              item.ativo && item.forma_pagamento.ativo,
          ),
        );
        setSelectedPayment(data[0]);
      } catch (error) {
        console.log(error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar métodos de pagamento.',
        });
      }
    };
    fetchData();
  }, [addToast, selectedCompanyId]);

  useEffect(() => {
    if (paymentsMethod && selectedPaymentMethod) {
      setSelectedPayment(
        paymentsMethod?.find(
          (pay: IFormaPagamentoEmpresa) =>
            pay.id === selectedPaymentMethod?.paymentMethod.id,
        ) ?? paymentsMethod[0],
      );

      selectedPaymentMethod.changeMoney &&
        setChangeMoney(
          moneyMask(formateBrPrice(selectedPaymentMethod.changeMoney)),
        );
    }
  }, [paymentsMethod, selectedPaymentMethod]);

  useEffect(() => {
    if (selectedPayment) {
      setSelectedPaymentMethod({
        paymentMethod: selectedPayment,
        changeMoney:
          selectedPayment.forma_pagamento.descricao === 'Dinheiro'
            ? Number(
                changeMoney
                  .replace('.', '')
                  .replace(',', '.')
                  .replace('R$', '')
                  .trim(),
              )
            : null,
      });
    }
  }, [changeMoney, selectedPayment, setSelectedPaymentMethod]);

  useEffect(() => {
    const value = +discount
      .replace('.', '')
      .replace(',', '.')
      .replace('R$', '')
      .trim();

    if (value > 0) setDiscountOnTheOutside(value);
    else setDiscountOnTheOutside(null);
  }, [discount, setDiscountOnTheOutside]);

  useEffect(() => {
    const schedulingParams = async (): Promise<void> => {
      try {
        const res = await empresaApi.getParametro(
          selectedCompanyId,
          'entrega_agendada',
        );
        if (res) setScheduledIsActive(JSON.parse(res.role).status);
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Configurações de agendamento não encontrado.',
        });
      }
    };

    schedulingParams();
  }, [addToast, selectedCompanyId]);

  useEffect(() => {
    const changeMoneyNumber = +changeMoney
      .replace('.', '')
      .replace(',', '.')
      .replace('R$', '')
      .trim();

    if (changeMoneyNumber > 0 && finalPrice > changeMoneyNumber)
      setMoneyIsError(true);
    else setMoneyIsError(false);
  }, [changeMoney, finalPrice]);

  const canChangeCompany = !isEditing && companies.length > 0;

  const closest = distances.reduce(
    (acc, loc) => {
      return acc.distance < loc.distance ? acc : loc;
    },
    { id: 0, distance: Number.POSITIVE_INFINITY },
  );

  return (
    <S.Container>
      <div className="header">
        <h1>Finalização</h1>
        <button type="button" className="box continue" onClick={prevStep}>
          <BiPlus size={22} style={{ marginRight: -10 }} />
          Continuar comprando
        </button>
      </div>

      <div className="body">
        {canChangeCompany && (
          <div className="companies">
            <h2>1. De onde o pedido vai sair?</h2>
            <div className="companies-list">
              {companies.map((company) => (
                <CompanyTile
                  key={company.id}
                  closest={
                    distances.length > 0 ? closest?.id === company.id : false
                  }
                  selected={company.id === selectedCompanyId}
                  name={company.name}
                  current={user.empresa_id === company.id}
                  distance={
                    distances.find((c) => c.id === company.id)?.distance
                  }
                  onClick={() => setSelectedCompanyId(company.id)}
                />
              ))}
            </div>
          </div>
        )}
        <div className="scheduling">
          <h2>{canChangeCompany ? 2 : 1}. Agendamento</h2>
          <S.CustomCheck
            title={
              !scheduledIsActive
                ? 'Configuração de agendamento está desabilitado.'
                : undefined
            }
            disabled={!scheduledIsActive}
            selected={!!scheduledDelivery}
            type="button"
            className="box"
            onClick={() => {
              if (scheduledIsActive) setModalSchedulingIsOpen(true);
              else
                addToast({
                  type: 'error',
                  title: 'Configuração de agendamento desabilitado.',
                });
            }}
          >
            <BiCalendarPlus size={24} />
            Agendar pedido
          </S.CustomCheck>

          {scheduledDelivery && (
            <p>
              {'Pedido agendado para o dia '}
              <strong>
                {moment(scheduledDelivery).format('DD')}
                {' de '}
                {moment(scheduledDelivery).format('MMMM')}
                {' de '}
                {moment(scheduledDelivery).format('YYYY')}
              </strong>
              {', às '}
              <strong>{moment(scheduledDelivery).format('HH:mm')}</strong>.
            </p>
          )}
        </div>

        <div className="form_of_payment">
          <h2>{canChangeCompany ? 3 : 2}. Forma de pagamento</h2>
          <div className="forms">
            {paymentsMethod ? (
              paymentsMethod
                .filter((item) => item.ativo && item.forma_pagamento.ativo)
                .map((item) => (
                  <S.CustomCheck
                    type="button"
                    className="box"
                    selected={item.id === selectedPayment?.id}
                    onClick={() => setSelectedPayment(item)}
                  >
                    <img
                      src={`${process.env.REACT_APP_SERVER_URL}/files/${item.forma_pagamento.imagem}`}
                      alt={item.forma_pagamento.descricao}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = DefaultImg;
                      }}
                    />
                    {item.forma_pagamento.descricao}
                  </S.CustomCheck>
                ))
            ) : (
              <S.CustomCircularProgress />
            )}
          </div>
          {selectedPayment &&
            selectedPayment?.forma_pagamento.descricao === 'Dinheiro' && (
              <Input
                label="Troco para quanto?"
                placeholder="Ex.: 25,50"
                value={changeMoney}
                onChange={(event) => {
                  const { value } = event.target;
                  setChangeMoney(moneyMask(value));
                }}
                error={moneyIsError ? 'Valor inferior ao total' : undefined}
              />
            )}
          {selectedPayment &&
            selectedPayment.forma_pagamento.descricao === 'Pix' && (
              <button type="button" className="box pix">
                <p>
                  {'Chave: '}
                  <strong>
                    {lerChave(selectedPayment.descricao, 'Pix') || 'Nenhum'}
                  </strong>
                </p>
                <CopyToClipboard
                  text={lerChave(selectedPayment.descricao, 'Pix')}
                  onCopy={() => {
                    addToast({
                      title: 'Copiado!',
                      type: 'success',
                    });
                  }}
                >
                  <p>
                    <strong>COPIAR</strong>
                  </p>
                </CopyToClipboard>
              </button>
            )}
        </div>

        <div className="discount_coupon">
          <h2>{canChangeCompany ? 4 : 3}. Cupom de desconto</h2>
          <div className="coupon">
            <p>{selectedCoupon?.code ?? 'Nenhum'}</p>
            {selectedCoupon ? (
              <Button
                onClick={() => {
                  setSelectedCoupon(null);
                  addToast({
                    type: 'success',
                    title: 'Cupom removido.',
                  });
                }}
              >
                Remover cupom
              </Button>
            ) : (
              <Button
                onClick={() => {
                  if (selectedClient) {
                    setModalCouponIsOpen(true);
                    return;
                  }
                  addToast({
                    type: 'info',
                    title: 'Selecione um cliente.',
                  });
                }}
              >
                Adicionar cupom
              </Button>
            )}
          </div>
        </div>

        <div className="discount_on_the_outside">
          <h2>{canChangeCompany ? 5 : 4}. Aplicar desconto</h2>

          <Input
            placeholder="Ex.: 25,50"
            value={discount}
            onChange={(event) => {
              const { value } = event.target;
              setDiscount(moneyMask(value));
            }}
            error={
              +discount
                .replace('.', '')
                .replace(',', '.')
                .replace('R$', '')
                .trim() > 0 && finalPrice < 0
                ? 'Valor superior ao total'
                : undefined
            }
          />
        </div>

        <div className="comments">
          <h2>{canChangeCompany ? 6 : 5}. Observação</h2>

          <TextArea
            placeholder="Observação"
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
          />
        </div>
      </div>

      {cart.length > 0 ? (
        <S.CartButton
          className="cart"
          onClick={handleFinalizeOrder}
          disabled={isLoading}
        >
          <p>{cart.length}</p>
          <p>FINALIZAR</p>
          <p>{formateBrPrice(finalPrice)}</p>
        </S.CartButton>
      ) : null}

      {modalSchedulingIsOpen && (
        <ModalScheduling
          onClose={() => setModalSchedulingIsOpen(false)}
          setScheduledDelivery={setScheduledDelivery}
        />
      )}

      {modalCouponIsOpen && (
        <ModalCoupon
          cart={cart}
          selectedClient={selectedClient}
          setModalCouponIsOpen={setModalCouponIsOpen}
          handleSelectedCoupon={setSelectedCoupon}
        />
      )}

      {modalChangeMoneyIsOpen && (
        <ModalChangeMoney
          onClose={() => setModalChangeMoneyIsOpen(false)}
          finalPrice={finalPrice}
          handleChangeMoney={setChangeMoney}
        />
      )}
    </S.Container>
  );
};
